import classes from './tests.module.scss';
import { TestLinkDTO } from "../domain/TestLinkDto";
import { UniqueIdentifier } from '@dnd-kit/core';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { DragHandle } from '../../components/DragHandle/DragHandle';
import TestLinkBody from './TestLinkBody';
import LnIcon from 'src/components/LnIcon';

const TestLink = (props: {
    readOnly: boolean, deleteHandler: (testId: string) => void, test: TestLinkDTO, active?: UniqueIdentifier,
    dragged?: boolean
}) => {
    const { test, active, dragged, deleteHandler, readOnly } = props;

    const {
        attributes,
        listeners,
        setNodeRef,
        transform,
        transition,
    } = useSortable({ id: test.Id });

    const style = {
        transform: CSS.Transform.toString(transform),
        transition,
        opacity: dragged ? "75%" : ""
    };


    return (
        <div ref={setNodeRef} id={test.Id} style={style} className={[classes.testListing, 'ps-3 py-3 my-3', (active === test.Id ? classes.active : "")].join(' ')} >

            <table role="presentation">
                <tbody>
                    <tr>
                        <td>
                            <TestLinkBody readOnly={readOnly} test={test} className='' />
                        </td>
                        <td>
                            {!test.AuthoringOk && <LnIcon name="alert" className=" mt-3 icon-small" />}

                        </td>
                        <td>
                            {!readOnly && (
                                <button className="btn btn-link ms-3 mt-3" type="button" onClick={() => deleteHandler(test.Id)}>
                                    <LnIcon name="delete" className='icon-small' />
                                </button>
                            )}
                        </td>
                        <td>
                            {!readOnly && <div><DragHandle {...attributes} {...listeners} /></div>}
                        </td>
                    </tr>
                </tbody>


            </table>
        </div>)

}

export default TestLink;

